export default "__VITE_ASSET__Dr7kIChj__"